module.exports = __webpack_public_path__ + "static/media/OWU_BGZBNPP_REVOLVINGCPI_3_3.2_2018_Cardif_Agro Ekspres.9aacf5f3.pdf";